import { Component} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTable } from 'primeng/primeng';
import { ConfirmationService, LazyLoadEvent, Message, SelectItem } from 'primeng/api';
import { BusinessCategory, EditBusinessCategory } from '../../../models/inModels/business-category';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { BusinessService } from '../../../services/business/business-category.service';

@Component({
  selector: 'app-business-category',
  templateUrl: './business-category.component.html',
  styleUrls: ['./business-category.component.css']
})
export class BusinessCategoryComponent {
loading: boolean;
messages: Message[];
category: BusinessCategory[];
rows: SelectItem[];
error: Message[];
rowEvent: LazyLoadEvent;
totalRecords: number;
filteredRecords: number;
selectedRows: number;


  constructor( 
    private rout: ActivatedRoute,
    private router: Router,
    private businessService: BusinessService,
    private confirmationService: ConfirmationService,
    private auth: AuthenticationService) { 

    this.loading = true;
    this.rows = [];
    this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
    }
    changeRows(event): void {
      this.loadCategory(this.rowEvent);
    }
  
    reset(dt: DataTable, gb: HTMLInputElement) {
      gb.value = '';
      dt.reset();
    } 

    loadCategory(event: LazyLoadEvent): void {
      this.loading = true;
      event.rows = this.selectedRows;
      this.rowEvent = event;
      this.businessService.search(event).then(
        dataPager => {
          this.category = dataPager.Data;
          this.filteredRecords = dataPager.FilteredRecords;
          this.totalRecords = dataPager.TotalRecords;
          this.loading = false;
        },
        error => {
          this.loading = false;
          console.log(error);
          this.category = [];
          this.totalRecords = 0;
          this.filteredRecords = 0;
          this.error = [];
          this.error.push({ severity: 'error', summary: 'Error', detail: error });
        }
      );

    }
    update(category : BusinessCategory) {
      console.log(category);
      this.router.navigate(['business-category/edit/' + category.Id]);
      // window.open("users/edit/" + user.Id);
    }

    
    delete(category : BusinessCategory) {
      console.log(category);
      this.confirmationService.confirm({
        message: `Are you sure you want to delete ${category.Name}?`,
        header: 'Confirmation',
        icon: 'fa fa-trash-o',
        accept: () => {
          this.loading = true;
          this.businessService.delete(category.Id).then(
            result => {
              this.loading = false;
              this.loadCategory(this.rowEvent);
            },
            error => {
              this.loading = false;
              this.error = [];
              this.error.push({ severity: 'error', summary: 'Error', detail: error });
            });
        }
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/business/business-category/business-category.component.ts